var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4773 4.0227C15.7409 4.28631 15.7409 4.71369 15.4773 4.9773L7.2273 13.2273C6.96369 13.4909 6.53631 13.4909 6.2727 13.2273L2.5227 9.4773C2.2591 9.21369 2.2591 8.78631 2.5227 8.5227C2.78631 8.2591 3.21369 8.2591 3.4773 8.5227L6.75 11.7954L14.5227 4.0227C14.7863 3.7591 15.2137 3.7591 15.4773 4.0227Z",
    fill: "#1181F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4697 3.96967C14.7626 3.67678 15.2374 3.67678 15.5303 3.96967C15.8232 4.26256 15.8232 4.73744 15.5303 5.03033L7.28033 13.2803C6.98744 13.5732 6.51256 13.5732 6.21967 13.2803L2.46967 9.53033C2.17678 9.23744 2.17678 8.76256 2.46967 8.46967C2.76256 8.17678 3.23744 8.17678 3.53033 8.46967L6.75 11.6893L14.4697 3.96967ZM15.4243 4.07574C15.1899 3.84142 14.8101 3.84142 14.5757 4.07574L6.80303 11.8484C6.77374 11.8777 6.72626 11.8777 6.69697 11.8484L3.42426 8.57574C3.18995 8.34142 2.81005 8.34142 2.57574 8.57574C2.34142 8.81005 2.34142 9.18995 2.57574 9.42426L6.32574 13.1743C6.56005 13.4086 6.93995 13.4086 7.17426 13.1743L15.4243 4.92426C15.6586 4.68995 15.6586 4.31005 15.4243 4.07574Z",
    fill: "#1181F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.01fd73be75e351079617d4a3c9218850.svg";
export { ForwardRef as ReactComponent };